(ns iris.error.events
  (:require
   [re-frame.core :as re-frame]))


(re-frame/reg-event-db
 ::set-error
 (fn [db [_ value]]
   (-> db
       (assoc-in [:route :panel] :error-panel)
       (assoc-in [:error] value))))